(function() {
    'use strict';
    /*
     * Copyright (c) 2015 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .service('IhhPersonResolver', PersonResolverSvc);

    PersonResolverSvc.$inject = ['Utilities', 'RestResources'];

    /**
     * A service to resolve whether to override the name of an existing person when creating a secondary individual.
     * @ngdoc service
     * @memberOf ihh-common-web
     * @name IhhPersonResolver
     */
    function PersonResolverSvc(Utilities, RestResources) {

        var fixConflict = function(secondaryIndividual, person, okFn, dismissFn) {
            Utilities.modal('user/resolve-person-conflict.tpl.html', 'PersonConflictCtrl', {
                secondaryIndividual: function() {
                    return secondaryIndividual;
                },
                person: function() {
                    return person;
                }
            }, function(usePersonName) {
                okFn(usePersonName);
            }, function() {
                if (angular.isFunction(dismissFn)) {
                    dismissFn();
                }
            });
        };

        /**
         * Searches for an existing person with the same username as the passed person, and if found, shows a dialog prompting the
         * user to choose old or new values. The success function is called if the person is chosen.
         * @ngdoc method
         * @name resolvePerson
         * @memberOf ihh-common-web.IhhPersonResolver
         * @param {Object} secondaryIndividual
         * @param {Function} successFn called if the user chooses a person, with the person record that should be used for the new
         * user context
         * @param {Function} errorFn called on error
         * @param {Function} dismissFn called when the modal is dismissed
         */
        this.resolvePerson = function(secondaryIndividual, successFn, errorFn, dismissFn) {
            if (!Utilities.isDefinedAndNotNull(secondaryIndividual.person)) {
                successFn(secondaryIndividual);
            }
            else {
                RestResources.getPersonsResource().query({
                    username: secondaryIndividual.person.username
                }, function(queryResult) {
                    var foundPersons = queryResult.items;
                    if (foundPersons.length === 1) {
                        var foundPerson = foundPersons[0];
                        if (!Utilities.isDefinedAndNotNull(secondaryIndividual.person)) {
                            secondaryIndividual.person = {};
                        }
                        secondaryIndividual.person.id = foundPerson.id;

                        if (secondaryIndividual.firstName !== foundPerson.firstName || secondaryIndividual.lastName !== foundPerson.lastName) {
                            fixConflict(secondaryIndividual, foundPerson, function(usePersonName) {
                                var individual = angular.extend({}, secondaryIndividual);
                                if (usePersonName) {
                                    individual.firstName = foundPerson.firstName;
                                    individual.lastName = foundPerson.lastName;
                                }
                                successFn(individual);
                            }, dismissFn);
                        }
                        else {
                            successFn(secondaryIndividual);
                        }
                    }
                    else {
                        secondaryIndividual.person.id = null;
                        secondaryIndividual.person.lastName = secondaryIndividual.lastName;
                        secondaryIndividual.person.firstName = secondaryIndividual.firstName;
                        successFn(secondaryIndividual);
                    }
                }, function(error) {
                    if (errorFn) {
                        errorFn(error);
                    }
                });
            }
        };
    }
})();